const useFormatParams = () => {
  const formatParams = params => {
    if (!params) return { paramsFormatted: "", validParams: {} }

    const objectParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== null && value !== "" && value !== undefined
      )
    )

    const validParams = Object.fromEntries(
      Object.entries(params)
        .filter(
          ([_, value]) => value !== null && value !== "" && value !== undefined
        )
        .map(([key, value]) => [key, String(value)])
    )
    const paramsFormatted = new URLSearchParams(validParams).toString()

    return { paramsFormatted, validParams, objectParams }
  }

  return { formatParams }
}

export default useFormatParams
